<template>
  <v-card flat outlined>
    <v-data-table
      hide-default-header
      class="table"
      :headers="headers"
      :items="subBenefits"
      hide-default-footer
      mobile-breakpoint="600"
      show-expand
      :expanded.sync="expanded"
      item-key="LabelEn"
      @click:row="setExpanded"
      :items-per-page="subBenefits.length"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td class="expand-icon-detail">
            <v-icon
              v-if="item.SubBenefits && item.SubBenefits.length"
              @click.prevent="setExpanded(item)"
              class="v-data-table__expand-icon"
              :class="{ 'v-data-table__expand-icon--active': item.isExpanded }"
            >
              mdi-chevron-down
            </v-icon>
          </td>
          <td
            v-if="$vuetify.lang.current === 'fr'"
            class="text-subtitle-2 text-left w320"
            style=""
            :class="item.IsGroupHeader ? 'font-weight-bold' : ''"
          >
            {{ item.LabelFr }}
          </td>
          <td
            v-else
            class="text-subtitle-2 text-left w320"
            :class="item.IsGroupHeader ? 'font-weight-bold' : ''"
          >
            {{ item.LabelEn }}
          </td>
          <td class="text-subtitle-2 text-left mw160">
            {{
              $helpers.fillFormattedParams(
                item.AllowedMessage.message
                  ? $t(
                      "components.benefits_balances_table.message." +
                        item.AllowedMessage.message
                    )
                  : "",
                item.AllowedMessage.formattedParams
              )
            }}
          </td>
          <td class="text-subtitle-2 text-left w120">
            {{
              item.UsedMessage
                ? $helpers.fillFormattedParams(
                    item.UsedMessage.message,
                    item.UsedMessage.formattedParams
                  )
                : item.Used
            }}
          </td>
          <td class="text-subtitle-2 text-left w120">
            {{
              item.RemainingMessage
                ? $helpers.fillFormattedParams(
                    item.RemainingMessage.message,
                    item.RemainingMessage.formattedParams
                  )
                : item.Remaining
            }}
          </td>
          <td class="text-subtitle-2 text-left w250">
            {{ $helpers.formatDate(item.RenewalDate) }}
          </td>
        </tr>
      </template>
      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template v-slot:expanded-item="{ headers, item }">
        <td class="expanded-detail" :colspan="headers.length">
          <benefit-detail :subBenefits="item.SubBenefits" />
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import BenefitDetail from "@/components/MemberView/BenefitBalance/BenefitDetail.vue";
export default {
  name: "BenefitDetail",
  props: {
    subBenefits: Array,
  },
  data() {
    return {
      expanded: [],
    };
  },
  components: {
    BenefitDetail,
  },
  computed: {
    ...mapGetters("data", ["providerServices"]),
    headers() {
      return [
        // {
        //   text: "",
        //   value: "data-table-expand",
        //   cellClass: "expand",
        //   class: "text-subtitle-2 primary white--text",
        // },
        {
          text: this.$t("components.claims_history.coverage_benefit"),
          align: "left",
          sortable: true,
          value: this.$vuetify.lang.current === "fr" ? "LabelFr" : "LabelEn",
          cellClass: "text-subtitle-2 pl-4",
          class: "text-subtitle-2 primary white--text pl-4",
        },
        {
          text: this.$t("components.benefits_balances_table.header.allowed"),
          align: "left",
          sortable: true,
          value: "Allowed",
          cellClass: "text-subtitle-2",
          class: "text-subtitle-2 primary white--text",
        },
        {
          text: this.$t("components.benefits_balances_table.header.used"),
          align: "left",
          sortable: true,
          value: "Used",
          cellClass: "text-subtitle-2",
          class: "text-subtitle-2 primary white--text",
        },
        {
          text: this.$t("components.benefits_balances_table.header.remaining"),
          align: "left",
          sortable: true,
          value: "Remaining",
          cellClass: "text-subtitle-2",
          class: "text-subtitle-2 primary white--text",
        },
        {
          text: this.$t(
            "components.benefits_balances_table.header.rewnewal_date"
          ),
          align: "left",
          sortable: true,
          value: "RenewalDate",
          cellClass: "text-subtitle-2",
          class: "text-subtitle-2 primary white--text",
        },
      ];
    },
  },
  methods: {
    setExpanded(item) {
      if (item.SubBenefits?.length) {
        if (item.isExpanded) {
          this.expanded = this.expanded.filter((o)=>o.LabelEn !== item.LabelEn);
        } else {
          this.expanded.push(item);
        }
        item.isExpanded = !item.isExpanded;
      }
    },
    formatAllowedMessage(item) {
      if (!item.AllowedMessage) return "";
      let allowedMessage = item.AllowedMessage;
      let message = allowedMessage.message || "";
      if (allowedMessage.formattedParams.length) {
        allowedMessage.formattedParams.forEach((param) => {
          message = message.replace("{}", param);
        });
      }
      return message;
    },
  },
};
</script>
<style scoped>

.table >>> tr:hover {
  background-color: transparent !important;
}
.table >>> td {
  font-size: 0.75rem !important;
  font-weight: 500;
  border-bottom: none !important;
}
.table >>> th {
  height: 20px !important;
  color: grey !important;
}
.table >>> td {
  height: 30px !important;
}
.table >>> td.expand-icon-detail {
  padding: 0 0 0 8px !important;
  width: 28px !important;
}
.total {
  border-top: 1px solid grey !important;
}
.label {
  font-weight: 500 !important;
}
.table >>> .header-text {
  text-align: center !important;
}
.w250 {
  width: 250px
}
.w120 {
  width: 120px
}
.w320 {
  width: 320px
}
.mw160 {
  min-width: 160px
}
</style>
